import React from "react";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../LinkProvider";

import logo from "../img/logo.svg";

const LINKS = [
  { key: "footer.links.terms", href: "/docs/Client%20agreement%20Pensador.pdf" },
  { key: "footer.links.privacy", href: "/docs/PRIVACY%20POLICY%20Pensador.pdf" },
  { key: "footer.links.conflict", href: "/docs/CONFLICT%20OF%20INTERESTS%20Pensador.pdf" },
];

const PHONE = "+41762090384";

function getEmail() {
  if (typeof window === "undefined") return "";
  return `support@${window.location.hostname.replace(/^www\./, "")}`;
}

function Footer() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const email = getEmail();

  return (
    <footer className="bg-[#30425a]">
      <Fade triggerOnce direction="up" duration={700} className="glcontainer py-[60px] sm:py-[80px]">
      <div>
        {/* Brand + CTA */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-[24px] mb-[40px]">
          <img
            src={logo}
            alt="PENSADOR Partner AG"
            className="h-[40px] w-auto self-start sm:self-auto brightness-0 invert"
          />
        </div>

        {/* Divider */}
        <div className="h-px bg-[rgba(255,255,255,0.12)] mb-[32px]" />

        {/* Disclaimer */}
        <div className="mb-[28px]">
          <p className="font-['Inter'] font-semibold text-[12px] text-white mb-[12px] uppercase tracking-[0.5px]">
            {t("footer.disclaimer.title")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8] mb-[10px]">
            {t("footer.disclaimer.text1")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8] mb-[10px]">
            {t("footer.disclaimer.text2")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8]">
            {t("footer.disclaimer.text3")}
          </p>
        </div>

        {/* Company info */}
        <div className="mb-[28px]">
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8]">
            {t("footer.company.address")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8]">
            ZEFIX: {t("footer.company.regNumber")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8]">
            {t("footer.company.lei")}
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8] mt-[12px]">
            {t("footer.company.phone")}:{" "}
            <a href={`tel:${PHONE}`} className="hover:text-white transition-colors">
              {PHONE}
            </a>
          </p>
          <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] leading-[1.8] mb-[10px]">
            {t("footer.company.email")}:{" "}
            <a href={`mailto:${email}`} className="hover:text-white transition-colors">
              {email}
            </a>
          </p>
          <div className="flex flex-wrap gap-[20px]">
            <a
              href="https://www.zefix.ch/en/search/entity/list/firm/356375"
              target="_blank"
              rel="noopener noreferrer"
              className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] underline hover:text-white transition-colors"
            >
              {t("footer.company.zefix")}
            </a>
            <a
              href="https://search.gleif.org/#/record/52990056M413TJXLAZ72"
              target="_blank"
              rel="noopener noreferrer"
              className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.7)] underline hover:text-white transition-colors"
            >
              {t("footer.company.gleif")}
            </a>
          </div>
        </div>

        {/* Legal links */}
        <div className="flex flex-wrap gap-[20px] mb-[24px]">
          {LINKS.map((item) => (
            <a
              key={item.key}
              href={item.href}
              target={item.href !== "#" ? "_blank" : undefined}
              rel={item.href !== "#" ? "noopener noreferrer" : undefined}
              className="font-['Inter'] font-light text-[14px] text-[rgba(255,255,255,0.8)] hover:text-white transition-colors"
            >
              {t(item.key)}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="font-['Inter'] font-light text-[12px] text-[rgba(255,255,255,0.55)]">
          {t("footer.copyright")}
        </p>
      </div>
      </Fade>
    </footer>
  );
}

export default Footer;
